<template>
  <div
    class="rows"
    :class="{
      'closed-bets': closedBets,
    }"
  >
    <div v-for="bet in betResponseSource">
      <div class="bet-slip bet-slip-content-item-wrapper">
        <span class="bet-type d-flex align-items-center justify-content-between">
          <span>{{ getTranslatedBetType(bet.WagerType) }}</span>

          <span class="ticket-date text-right" v-if="placed && bet.IsSuccess">
            {{ $t('BetSlip.PlacedAt') }}: {{ getDate(bet) }}
          </span>
          <span
            class="ticket-remove text-right d-flex align-items-center ml-auto"
            v-if="isLinesChangedItem && !betPlaceStatus.loading"
          >
            <span style="color: #ed6706" class="mr-2 text-nowrap">
              {{ $t('BetSlip.OddsUpdated') }}
            </span>

            <i class="icon icon-times cursor-pointer" style="color: #343a40" @click="removeBet(bet)"></i>
          </span>
          <span class="ticket-remove text-right" v-if="isConfirmation">
            <span style="color: #ce5600" v-if="isConfirmOddChanged(bet)">
              {{ $t('BetSlip.OddsUpdated') }}
            </span>
          </span>

          <span class="placed-bet text-right" style="color: #38ac26" v-if="placedIndicator">
            {{ $t('BetSlip.BetPlaced') }}
          </span>
          <span class="bet-closed text-right" v-if="closedBets">
            {{ $t('BetSlip.BetClosed') }}
          </span>
        </span>
        <div class="bet-slip-header light">
          <div class="title">
            <div class="d-flex flex-column">
              <span v-if="showSuccess && bet.IsSuccess" class="ml-2">
                <i class="icon file-check text-success"></i>
              </span>
            </div>
            <div class="body">
              <small v-if="getSubTypeDescriptionIfAny(bet)">({{ getSubTypeDescriptionIfAny(bet) }})</small>
              <bet-slip-confirmation-row
                :is-confirmation="isConfirmation"
                :bet="bet"
                v-if="!showCheckBoxes"
              ></bet-slip-confirmation-row>
              <bet-slip-confirmation-row-with-checkbox
                :is-confirmation="isConfirmation"
                :bet="bet"
                v-if="showCheckBoxes"
              ></bet-slip-confirmation-row-with-checkbox>
              <div style="padding-left: 15px" v-if="bet.open_spots">
                <h1 style="font-size: 12px">{{ $t('Open Spots') }}: {{ bet.open_spots }}</h1>
              </div>
              <div
                v-if="selectedType !== 'if_win' && selectedType !== 'if_win_or_tie'"
                class="d-flex justify-content-between align-items-center risk-win-area"
              >
                <span class="title text-left" style="font-size: 13px"
                  >{{ $t('Risk') }} :
                  <span><price :val="getRiskAmount(bet)" /></span>
                  <span v-if="activeFreeBet"> ({{ $t('BonusModal.FreePlay') }})</span></span
                >
                <span class="title text-right" style="font-size: 13px"
                  >{{ $t('Win') }} : <price :val="getWinAmount(bet)"
                /></span>
              </div>

              <div class="placed-bottom" v-if="placed && bet.IsSuccess">
                <span class="ticket-id">
                  {{ $t('BetSlip.TicketId') }}:
                  <span class="value">{{ getFirstTicketId(bet) }}</span>
                </span>

                <bet-ticket-ids-area :bet="bet" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------------------------------ BET PLACED ---------------------------->
    <div v-if="placed" class="placed-content mb-2 mt-2">
      <div class="d-flex justify-content-between" style="padding: 0px 14px">
        <strong style="font-size: 13px">{{ $t('BetSlip.Risk') }}</strong>
        <strong><price :val="getTotalRiskViewPlaced" /> </strong>
      </div>
      <div
        class="d-flex justify-content-between"
        style="padding: 0px 14px"
        v-if="!!parseFloat(calculatedTotalTaxAndFee.totalRiskTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{
          $t('BetSlip.RiskTaxAmount', { indic: $taxHelper.totalTaxIndic().risk })
        }}</strong>
        <strong><price :val="calculatedTotalTaxAndFee.totalRiskTaxAndFee" /></strong>
      </div>
      <div
        class="d-flex justify-content-between"
        style="padding: 0px 14px"
        v-if="!!parseFloat(calculatedTotalTaxAndFee.totalRiskTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{ $t('BetSlip.RiskCost') }}</strong>
        <strong><price :val="placedTotalRiskAmount" /></strong>
      </div>
      <div class="d-flex justify-content-between" style="padding: 0px 14px">
        <strong style="font-size: 14px">{{ $t('BetSlip.Potential Win Amount') }}</strong>
        <strong><price :val="placedTotalWinAmount" /></strong>
      </div>
      <div
        class="d-flex justify-content-between"
        style="padding: 0px 14px"
        v-if="!!parseFloat(calculatedTotalTaxAndFee.totalWinTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{
          $t('BetSlip.WinTaxAmount', { indic: $taxHelper.totalTaxIndic().win })
        }}</strong>
        <strong><price :val="calculatedTotalTaxAndFee.totalWinTaxAndFee" /></strong>
      </div>
      <div
        class="d-flex justify-content-between"
        style="padding: 0px 14px"
        v-if="!!parseFloat(calculatedTotalTaxAndFee.totalWinTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{ $t('BetSlip.Pay') }}</strong>
        <strong><price :val="pay" /> </strong>
      </div>
    </div>

    <!------------------------------ CONFIRM ---------------------------->
    <div v-if="isConfirmation" class="placed-content mb-2 mt-2">
      <div class="d-flex justify-content-between getTotalRisk" style="padding: 0px 14px">
        <strong style="font-size: 13px">{{ $t('BetSlip.Risk') }}</strong>
        <strong><price :val="getTotalRiskView" /> </strong>
      </div>
      <div
        class="d-flex justify-content-between c_totalRiskTaxAndFee"
        style="padding: 0px 14px"
        v-if="!!parseFloat(c_totalRiskTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{
          $t('BetSlip.RiskTaxAmount', { indic: $taxHelper.totalTaxIndic().risk })
        }}</strong>
        <strong><price :val="c_totalRiskTaxAndFee" /></strong>
      </div>
      <div
        class="d-flex justify-content-between c_riskCost"
        style="padding: 0px 14px"
        v-if="!!parseFloat(c_totalRiskTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{ $t('BetSlip.RiskCost') }}</strong>
        <strong><price :val="c_riskCost" /></strong>
      </div>
      <div class="d-flex justify-content-between potentialWin" style="padding: 0px 14px">
        <strong style="font-size: 14px">{{ $t('BetSlip.Potential Win Amount') }}</strong>
        <strong><price :val="potentialWin" /></strong>
      </div>
      <div
        class="d-flex justify-content-between c_totalWinTaxAndFee"
        style="padding: 0px 14px"
        v-if="!!parseFloat(c_totalWinTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{
          $t('BetSlip.WinTaxAmount', { indic: $taxHelper.totalTaxIndic().win })
        }}</strong>
        <strong><price :val="c_totalWinTaxAndFee" /></strong>
      </div>
      <div
        class="d-flex justify-content-between c_pay"
        style="padding: 0px 14px"
        v-if="!!parseFloat(c_totalWinTaxAndFee) && !hasPlaceError"
      >
        <strong style="font-size: 13px">{{ $t('BetSlip.Pay') }}</strong>
        <strong><price :val="c_pay" /> </strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import BetSlipConfirmationRow from './BetSlipConfirmationRow';
import BetSlipConfirmationRowWithCheckbox from './BetSlipConfirmationRowWithCheckbox';
import { getTranslatedBetType } from './bet-slip-utils';
import { roundAmount } from '@/views/sports/components/bet-slip/bet-slip-utils';
import snq from 'snq';
import BetTicketIdsArea from './BetTicketIdsArea';
import { americanToDecimal } from './bet-slip-utils';

export default {
  components: {
    BetTicketIdsArea,
    BetSlipConfirmationRow,
    BetSlipConfirmationRowWithCheckbox,
  },
  props: [
    'betResponseSource',
    'showSuccess',
    'showCheckBoxes',
    'placed',
    'isConfirmation',
    'isLinesChangedItem',
    'closedBets',
    'placedIndicator',
    'closedBets',
  ],

  computed: {
    ...mapState('betSlip', ['selectedType', 'totalRiskWithoutTax', 'betConfirmationIds', 'betPlaceResponse']),
    ...mapGetters('player', ['currencySymbol']),
    ...mapState({
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      betPlaceResponse: (state) => state.betSlip.betPlaceResponse,
      betSlipBetCount: (state) => state.betSlip.betSlipBetCount,
      betPlaceStatus: (state) => state.betSlip.betPlaceStatus,
      betOptionsResponse: (state) => state.betSlip.betOptionsResponse,
    }),
    getFilteretSuccessBets() {
      return null;
    },
    betType() {
      return snq(() => this.selectedType);
    },
    /// RISK
    getTotalStraightRiskAmount() {
      return this.straights
        .map((item) => item.dgs_risk_amount || item.input_risk_amount)
        .reduce((accumulator, currentValue) => {
          return roundAmount(parseFloat(accumulator) + parseFloat(currentValue));
        }, 0);
    },
    getTotalStraightWinAmount() {
      return roundAmount(
        parseFloat(
          this.straights
            .map((item) => item.dgs_win_amount || item.input_win_amount)
            .reduce((accumulator, currentValue) => {
              return roundAmount(parseFloat(accumulator) + parseFloat(currentValue));
            }, 0),
        ),
      );
    },

    /// WIN
    getTotalNonStraightWinAmount() {
      if (
        this.nonStraights.find((item) => item.type === 'if_win') ||
        this.nonStraights.find((item) => item.type === 'if_win_or_tie')
      ) {
        return roundAmount(
          parseFloat(this.getWinAmountForIfBet(this.nonStraights[0])) +
            (this.betSlipBetCount - 1) * parseFloat(this.getRiskAmount(this.nonStraights[0])),
        );
      }

      return this.nonStraights.reduce((accumulator, currentValue) => {
        return roundAmount(parseFloat(accumulator) + parseFloat(this.getWinAmountForNonStraight(currentValue)));
      }, 0);
    },
    getTotalNonStraightRiskAmount() {
      if (
        this.nonStraights.find((item) => item.type === 'if_win') ||
        this.nonStraights.find((item) => item.type === 'if_win_or_tie')
      ) {
        return roundAmount(parseFloat(this.getRiskAmount(this.nonStraights[0])) * this.betSlipBetCount);
      }
      return this.nonStraights.reduce((accumulator, currentValue) => {
        return roundAmount(parseFloat(accumulator) + parseFloat(this.getRiskAmount(currentValue)));
      }, 0);
    },

    straights() {
      return snq(
        () => this.betResponseSource.filter((item) => !!item.IsSuccess).filter((item) => item.WagerType === 'straight'),
        [],
      );
    },
    nonStraights() {
      return this.betResponseSource.filter((item) => !!item.IsSuccess).filter((item) => item.WagerType !== 'straight');
    },
    getTotalRiskViewPlaced() {
      let resp = this.betPlaceResponse[0];
      if (!resp) {
        resp = this.betPlaceResponse.WagerResponseModel.bets[0].wager_header.risk;
        return roundAmount(parseFloat(resp));
      }
      return roundAmount(parseFloat(resp.input_risk_amount));
    },
    getTotalRiskView() {
      let mustApplyTax = this.$taxHelper.mustApplyTax;
      if (this.activeFreeBet) return '0.00';
      let riskAmount;
      if (this.betType === 'if_win') {
        riskAmount = roundAmount(parseFloat(this.getRiskAmount(this.nonStraights[0])));
      } else if (this.betType === 'round_robin') {
        riskAmount = this.betOptionsResponse.rrRisk;
        mustApplyTax = false;
      } else if (this.betType === 'parlay') {
        riskAmount = this.betOptionsResponse.input_risk_amount;
      } else {
        riskAmount = roundAmount(
          parseFloat(this.getTotalStraightRiskAmount) + parseFloat(this.getTotalNonStraightRiskAmount),
        );
      }

      if (mustApplyTax) {
        const appliedTaxRiskInputHidden = this.$taxHelper.applyTaxToRiskInputHidden({
          input_risk_amount: riskAmount,
        });
        return appliedTaxRiskInputHidden;
      }
      return riskAmount;
    },
    getTotalRisk() {
      if (this.betType === 'if_win') {
        return roundAmount(parseFloat(this.getRiskAmount(this.nonStraights[0])));
      } else if (this.betType === 'round_robin') {
        return this.betOptionsResponse.rrRisk;
      }
      if (this.activeFreeBet) return '0.00';
      var result = roundAmount(
        parseFloat(this.getTotalStraightRiskAmount) + parseFloat(this.getTotalNonStraightRiskAmount),
      );
      return result;
    },
    calculatedTotalTaxAndFee() {
      return this.$taxHelper.calculateTaxAndFeeFromWagerResponse(snq(() => this.betOptionsResponse, []));
    },
    hasPlaceError() {
      return !this.betOptionsResponse.IsSuccess;
    },
    riskCost() {
      return roundAmount(
        parseFloat(this.calculatedTotalTaxAndFee.totalRiskTaxAndFee) +
          parseFloat(this.getTotalStraightRiskAmount) +
          parseFloat(this.getTotalNonStraightRiskAmount),
      );
    },
    totalWin() {
      if (this.betType === 'round_robin') {
        return parseFloat(this.betOptionsResponse.rrTotalWin);
      }
      return parseFloat(this.getTotalStraightWinAmount) + parseFloat(this.getTotalNonStraightWinAmount);
    },
    potentialWin() {
      if (this.betType === 'if_win') {
        const bet = this.betOptionsResponse;
        const riskAmount = parseFloat(bet.input_risk_amount);

        const amount = bet.Selections.reduce((acc, cur) => {
          return acc + (riskAmount * americanToDecimal(cur.Odd) - riskAmount);
        }, 0);

        return (amount + riskAmount).toFixed(2);
      } else if (this.betType === 'round_robin') {
        return this.betOptionsResponse.rrTotalWin - parseFloat(this.betOptionsResponse.rrRisk);
      } else if (this.betType === 'straight') {
        const bet = this.betOptionsResponse;
        const amount = bet.Selections.reduce((acc, cur) => {
          var riskAmount = parseFloat(this.getTotalRiskView);
          return acc + (riskAmount * americanToDecimal(cur.Odd) - riskAmount);
        }, 0);
        return amount;
      } else if (this.betType === 'parlay') {
        return roundAmount(this.totalWin);
      }
      // return roundAmount(this.totalWin);
      if (this.isConfirmation) {
        return this.activeFreeBet
          ? roundAmount(this.totalWin - this.getTotalStraightRiskAmount)
          : roundAmount(this.totalWin - this.getTotalStraightRiskAmount);
      } else if (this.placed && this.betType === 'teaser') {
        const bet = this.betOptionsResponse;
        const riskAmount = parseFloat(bet.input_risk_amount);
        return roundAmount(this.totalWin);
      }
      return this.activeFreeBet
        ? roundAmount(this.totalWin)
        : roundAmount(this.totalWin + parseFloat(this.getTotalRisk));
    },
    pay() {
      if (this.activeFreeBet) return roundAmount(parseFloat(this.potentialWin));
      return roundAmount(
        parseFloat(this.getTotalRiskView) +
          parseFloat(this.potentialWin) -
          parseFloat(this.calculatedTotalTaxAndFee.totalWinTaxAndFee),
      );
    },
    c_riskWithoutTax() {
      return this.totalRiskWithoutTax;
    },
    c_totalRiskTaxAndFee() {
      return this.$taxHelper.calculatedRiskTaxes(this.getTotalRiskView, this.c_totalBetCount);
    },
    c_riskCost() {
      return this.$taxHelper.totalRiskCost(this.getTotalRiskView, this.c_totalBetCount, this.getTotalRiskView);
    },
    c_totalWinTaxAndFee() {
      if(this.betType === 'parlay'){
        return this.$taxHelper.calculatedWinTaxes(this.totalWin, this.c_totalBetCount);
      }
      // if (this.betOptionsResponse.fixedParlayMultiply)

      return this.$taxHelper.calculatedWinTaxes(this.totalWin - this.getTotalRiskView, this.c_totalBetCount);
    },
    c_pay() {
      if (this.activeFreeBet && this.isConfirmation) {
        return roundAmount(
          parseFloat(this.potentialWin) - parseFloat(this.c_totalWinTaxAndFee) - parseFloat(getTotalRiskView()),
        );
      }
      return roundAmount(
        parseFloat(this.getTotalRiskView) + parseFloat(this.potentialWin) - parseFloat(this.c_totalWinTaxAndFee),
      );
    },
    c_totalBetCount() {
      let totalBetCount = this.betResponseSource.length;
      const ifWin = snq(() => this.betResponseSource[0].WagerType === 'if_win');
      const ifReverse = snq(() => this.betResponseSource[0].WagerType === 'reverse');
      const ifRR = snq(() => this.betResponseSource[0].WagerType === 'round_robin');

      if (ifWin) {
        totalBetCount = this.betResponseSource[0].Selections.length;
      }

      if (ifReverse) {
        totalBetCount = this.betResponseSource[0].Selections.length;
        if (totalBetCount === 4) {
          totalBetCount = 6;
        }
      }

      if (ifRR) {
        totalBetCount = this.betResponseSource.reduce((acc, cur) => {
          const isYankee = cur.sub_type ? cur.sub_type.includes(',') : false;
          let yankeeBetCount;
          if (isYankee) {
            yankeeBetCount = cur.sub_type
              .split(',')
              .reduce(
                (acc, item) => acc + this.combination(Array.from({ length: cur.Selections.length }), +item).length,
                0,
              );

            return acc + yankeeBetCount;
          }

          return acc + this.combination(Array.from({ length: cur.Selections.length }), cur.sub_type).length;
        }, 0);
      }

      return totalBetCount;
    },

    placedTotalRiskAmount() {
      let riskAmount = 0;
      this.betResponseSource.forEach((b) => {
        riskAmount += parseFloat(b.input_risk_amount);
      });
      return riskAmount;
    },
    placedTotalWinAmount() {
      let winAmount = 0;
      this.betResponseSource.forEach((b) => {
        var winTaxes = this.$taxHelper.calculatedWinTaxes(parseFloat(b.input_win_amount), 1);
        winAmount += parseFloat(b.input_win_amount) - parseFloat(winTaxes) + parseFloat(b.input_risk_amount);
      });
      return winAmount;
    },
  },
  methods: {
    ...mapActions('betSlip', ['tryAddRejectedBet', 'tryRemoveRejectedBet', 'removeBetFromConfirmation', 'placeBet']),
    ...mapMutations('betSlip', ['removeBetConfirmationId', 'addBetConfirmationId']),
    roundAmount,
    getTranslatedBetType,
    isConfirmOddChanged(bet) {
      return bet.wait_for_accept_get_confirmation;
    },
    removeBet(bet) {
      this.removeBetConfirmationId(bet);
      this.tryAddRejectedBet(bet);

      if (
        this.betPlaceResponse &&
        this.betPlaceResponse.items &&
        (this.betPlaceResponse.items || []).filter((item) => !!item.IsSuccess).length === 0
      ) {
        console.log('Can place bet, there is no error');
        this.placeBet();
      }
    },
    combination(arr, num) {
      let r = [];

      for (let i = 0; i < arr.length; i++) {
        if (num === 1) r.push([arr[i]]);
        else {
          this.combination(arr.slice(i + 1), num - 1).forEach(function (val) {
            r.push([].concat(arr[i], val));
          });
        }
      }
      return r;
    },
    getSubTypeDescriptionIfAny(bet) {
      return bet.sub_type_description;
    },
    getRiskAmount(bet) {
      if (this.placed) return bet ? bet.input_risk_amount : '0.00';
      const mustApplyTax = this.$taxHelper.mustApplyTax;
      if (mustApplyTax && !bet.WagerType == 'round_robin') {
        const appliedTaxRiskInputHidden = this.$taxHelper.applyTaxToRiskInputHidden({
          input_risk_amount: bet.input_risk_amount,
        });
        return appliedTaxRiskInputHidden;
      }
      return bet ? bet.input_risk_amount : '0.00';
    },
    getWinAmount(bet) {
      if (this.isConfirmation) {
        if (this.betType == 'round_robin') {
          return this.betOptionsResponse.rrTotalWin;
        }
        return bet
          ? this.activeFreeBet
            ? roundAmount(parseFloat(bet.input_win_amount) - parseFloat(bet.input_risk_amount))
            : parseFloat(bet.input_win_amount)
          : '0.00';
      } else if (this.placed && this.betType === 'teaser') {
        return roundAmount(bet.input_win_amount);
      }
      return bet ? parseFloat(bet.input_win_amount) + parseFloat(bet.input_risk_amount) : '0.00';
    },
    getWinAmountWithoutRisk(bet) {
      return bet ? bet.input_win_amount - bet.input_risk_amount : '0.00';
    },
    getWinAmountForNonStraight(bet) {
      return this.activeFreeBet ? roundAmount(bet.input_win_amount - bet.input_risk_amount) : bet.input_win_amount;
    },
    getDate(bet) {
      return snq(() => this.$moment(bet.placed_at).format('DD-MM-YYYY'));
    },
    getFirstTicketId(bet) {
      // return bet.TicketNumber;
      let ids = [];
      let seperator = ',';
      const hasComma = snq(() => bet.TicketNumber.includes(','));
      const hasDel = snq(() => bet.TicketNumber.includes('|'));
      if (hasComma) {
        seperator = ',';
      }
      if (hasDel) {
        seperator = '|';
      }
      const parsed = bet.TicketNumber.split(seperator);
      parsed.forEach((p) => ids.push(p));
      return snq(() => ids.filter(Boolean)[0]);
    },
    getWinAmountForIfBet(bet) {
      return this.getWinAmountWithoutRisk(bet);
    },
  },
  created() {
    console.log('confirm');
    console.log(this.betOptionsResponse);
  },
};
</script>

<style>
.risk-win-area {
  color: #343a40;
}

.placed-content {
  color: #343a40;
  font-size: 13px !important;
}
</style>
